new MutationObserver(() => {
  document.querySelectorAll('a.swiper-slide[role="group"]').forEach(el => {
    el.removeAttribute('role');
  });
  document.querySelectorAll('div.swatch-view').forEach(el => {
    el.setAttribute('role', 'button');
    el.removeAttribute('aria-activedescendant')
  });
  document.querySelectorAll('img.gbbMixCascadeProductImage').forEach(el => {
    el.setAttribute('alt', '');
  });
  document.querySelectorAll('div.gbbMixCascadeProductsWrapper').forEach(el => {
    el.setAttribute('tabindex', '0');
  });
  document.querySelectorAll('picture').forEach(el => {
    el.removeAttribute('role')
  });
  document.querySelectorAll('.rte__table-wrapper').forEach(el => {
    el.setAttribute('tabindex', '0');
  });
}).observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('a.swiper-slide[role="group"]').forEach(el => {
  el.removeAttribute('role');
});

document.querySelectorAll('div.swatch-view').forEach(el => {
  el.setAttribute('role', 'button');
  el.removeAttribute('aria-activedescendant')
});

document.querySelectorAll('img.gbbMixCascadeProductImage').forEach(el => {
  el.setAttribute('alt', '');
});

document.querySelectorAll('div.gbbMixCascadeProductsWrapper').forEach(el => {
  el.setAttribute('tabindex', '0');
});

document.querySelectorAll('picture').forEach(el => {
  el.removeAttribute('role')
})

document.querySelectorAll('.rte__table-wrapper').forEach(el => {
  el.setAttribute('tabindex', '0');
});
